export default {
    cn : {
        // 顶部
        home: '首页',
        books: '书刊',
        video: '视频',
        exhibition: '展会活动',
        contactUs: '联系我们',
        mobile: '手机版',
        logRegister: '登录/注册',
        // 底部
        address: '浙江省瑞安市瑞光大道48-52号商城邮局二楼',
        qrcode: '二维码',
        weCom: '企业微信<br/>（张女士）',
        wechat: '微信公众号',
        anbei: '浙公安备',
        icp: '浙ICP备',
        mrCai: '蔡先生',
        mrZhang: '张女士',
        // 首页
        searchAll: '全部',
        inputPlaceholder: '请输入要搜索的产品...',
        searchBtn: '搜索',
        hot: '热门',
        request: '立即索取',
        free: '免费',
        videoTitle: '视频',
        more: '更多',
        release: '发布',
        exhibitionActivities: '展会活动',
        exhibitionType: '展览类型',
        exhibitionHallName: '展馆名称',
        eventTime: '活动时间',
        releaseOn: '发布于',
        viewCount: '浏览次数',
        recommendedEnterprises: '推荐企业',
        recommendedProducts: '推荐产品',
        bookName: '汽摩行业书刊',
        viewBook: '查看书刊内容',
        previousBooks: '以前的书籍和期刊',
        autopartPal: '汽邮筒',
        ourBrand: '合作伙伴',
        classification: '分类',
        all: '全部',
        check: '查看公司',
        // 联系我们
        contactUsTitle: '联系我们',
        contactIntro: '如果您有任何问题，请随时与我们联系',
        add: '地址',
        tel: '电话',
        email: '邮箱',
        message: '消息',
        inputTheme: '主题',
        inputCompany: '公司名称',
        inputName: '姓名',
        inputEmail: '邮箱',
        inputContact: '联系方式',
        inputAddress: '联系地址',
        inputInformation: '备注',
        sendBtn: '提交',
        moreBooks: '更多书刊',
        latestExhibition: '最新展览活动',
        latestExhibitionIntro: '推荐最新展会信息给你',
        collection: '收藏',
        productDisplay: '产品展示',
        internalPageDisplay: '内部展示',
        mapNavigation: '地图导航',
        contactTheFactory: '联系工厂',
        contactFactoryIntro: '如果您有任何疑问，请随时通过电话或在线咨询与我们联系',
        inputNeed: '请简要描述您的需求（非必填）',
        msgRequired: '必须填写',
        sendSuccess: '提交成功',
        creareAccountTitle: '注册账号',
        inputFirstName: '姓',
        inputLastName: '名',
        inputPassword: '密码',
        inputVerifyPassword: '确认密码',
        inputCountry: '所在国家',
        alreadyHaveAccount: '已有账号',
        login: '登录',
        createAccountBtn: '注册账号',
        signUpWithEmail: '使用电子邮件注册',
        registerSuccess: '注册成功',
        emailLogin: '邮箱登录',
        loginIntro: '汽邮桶-让汽摩配跑世界',
        signIn: '登录',
        loginSuccess: '登录成功',
        myCollection: '我的收藏',
        myFoot: '我的足迹',
        contactCustomerService: '联系客服',
        enterpriseSettled: '工厂入驻',
        settings: '设置',
        accountSetting: '设置',
        setTel: '手机',
        setNickname: '昵称',
        setCompanyName: '公司名称',
        setPassword: '登录密码',
        setMail: '邮箱管理',
        setPreserve: '保存',
        myFavorites: '我的收藏',
        sort: '排序',
        collectionTime: '时间',
        bookPages: '书刊页数',
        batchProcessing: '批量处理',
        userCenter: '个人中心',
        contactCustomerService: '联系客服',
        type: '类型',
        recommendation: '推荐工厂',
        region: '地区',
        factoryServices: '工厂服务',
        autoParts: '汽配',
        motorcycle: '摩配',
        starLabelFactory: '星标工厂',
        telephone: '电话',
        return: '返回',
        requestForBooksAndMagazines: '索取书籍和杂志',
        bookRequestIntro: '这本书免费，邮费自理',
        requestFormIntro: '备注',
    },
    en: {
        // 顶部
        home: 'Home',
        books: 'Books',
        video: 'Video',
        exhibition: 'Exhibition',
        contactUs: 'Contact Us',
        mobile: 'Mobile',
        logRegister: 'log/Register',
        // 底部
        address: 'Second Floor, Shangcheng Post Office, No. 48-52 Ruiguang Avenue, Rui\'an City, Zhejiang Province',
        qrcode: 'QR code',
        weCom: 'WeCom',
        wechat: 'WeChat',
        anbei: 'Zhejiang Gongwang Anbei',
        icp: 'Zhejiang ICP Bei',
        // 首页
        searchAll: 'Search all',
        inputPlaceholder: 'Please enter the product you want to search for...',
        searchBtn: 'Search',
        hot: 'HOT',
        request: 'Request',
        free: 'Free',
        videoTitle: 'VIDEO',
        more: 'More',
        release: 'Release',
        exhibitionActivities: 'Exhibition activities',
        exhibitionType: 'Exhibition type',
        exhibitionHallName: 'Exhibition Hall Name',
        eventTime: 'Event Time',
        releaseOn: 'Release on',
        viewCount: 'View count',
        recommendedEnterprises: 'Recommended Enterprises',
        recommendedProducts: 'Recommended Products',
        bookName: 'Auto and Motorcycle Parts Books',
        viewBook: 'View this year\'s book content',
        previousBooks: 'Previous books and periodicals',
        autopartPal: 'Autopart pal',
        ourBrand: 'Our Brand',
        classification: 'Classification',
        all: 'All',
        check: 'Check',
        // 联系我们
        contactUsTitle: 'CONTACT US',
        contactIntro: 'If you have any questions, please feel free to contact us at any time',
        add: 'ADD',
        tel: 'TEL',
        email: 'E-MAIL',
        message: 'Message',
        inputTheme: 'Theme',
        inputCompany: 'Company',
        inputName: 'Name',
        inputEmail: 'Email',
        inputFirstName: 'First Name',
        inputContact: 'Contact',
        inputAddress: 'Address',
        inputInformation: 'Information',
        sendBtn: 'Send',
        moreBooks: 'More books',
        latestExhibition: 'Latest Exhibition',
        latestExhibitionIntro: 'Recommend the latest exhibition information to you',
        collection: 'collection',
        productDisplay: 'Product display',
        internalPageDisplay: 'Internal page display',
        mapNavigation: 'Map navigation',
        contactTheFactory: 'Contact the factory',
        contactFactoryIntro: 'If you have any questions, please feel free to contact us by phone or online for consultation',
        inputNeed: 'Please briefly describe your needs (not mandatory)',
        msgRequired: ' is required',
        sendSuccess: 'Success',
        creareAccountTitle: 'CREATE ACCOUNT',
        inputLastName: 'Last Name',
        inputPassword: 'Password',
        inputVerifyPassword: 'Verify Password',
        inputCountry: 'Country',
        alreadyHaveAccount: 'Already have account',
        login: 'Login',
        createAccountBtn: 'Create Acccount',
        signUpWithEmail: 'Sign up with email',
        registerSuccess: 'Create Account Success',
        emailLogin: 'Email Login',
        loginIntro: 'Let the Auto and motor parts run the world',
        signIn: 'Sign In',
        loginSuccess: 'Login Success',
        myCollection: 'My collection',
        myFoot: 'My foot',
        contactCustomerService: 'Contact',
        enterpriseSettled: 'Enterprice settled',
        settings: 'Settings',
        mrCai: 'Mr.Cai',
        mrZhang: 'Mr.Zhang',
        accountSetting: 'Account Settings',
        setTel: 'Tel',
        setNickname: 'Nickname',
        setCompanyName: 'Company name',
        setPassword: 'Password management',
        setMail: 'Mailbox Management',
        setPreserve: 'preserve',
        myFavorites: 'My favorites',
        sort: 'Sort',
        collectionTime: 'Collection time',
        bookPages: 'Book pages',
        batchProcessing: 'Batch processing',
        userCenter: 'User Center',
        contactCustomerService: 'Contact customer service',
        type: 'Type',
        recommendation: 'Recommendation',
        region: 'Region',
        factoryServices: 'Factory services',
        autoParts: 'Auto Parts',
        motorcycle: 'Motorcycle',
        starLabelFactory: 'Star Label Factory',
        telephone: 'telephone',
        return: 'return',
        requestForBooksAndMagazines: 'Request for books and magazines',
        bookRequestIntro: 'This book is free of charge and postage is self paid',
        requestFormIntro: 'Remark',
    },
    get(){
        return this[this.getLang()]
    },
    set(lang){
        localStorage.setItem('lang', lang)
    },
    getLang(){
        let l = localStorage.getItem('lang')
        if(!l){
            // 判断中英文
            l = 'cn'
        }
        return l
    }
}


// WEBPACK FOOTER //
// ./src/assets/js/lang.js